import React, { useState, useEffect } from 'react';
import { API_URL } from '../services/api';
import {
  Grid,
  Container,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Box,
  IconButton,
  Skeleton
} from '@mui/material';

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import PersonIcon from '@mui/icons-material/Person';
import axios from 'axios';

interface DJ {
 id: number;
 name: string;
 bio: string;
 photo: string;
 social_instagram: string;
 social_facebook: string;
}

const DJs: React.FC = () => {
 const [djs, setDjs] = useState<DJ[]>([]);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 fetchDJs();
 }, []);

 const fetchDJs = async () => {
 try {
 const response = await axios.get(`${API_URL}/api/djs`);
 setDjs(response.data);
 } catch (error) {
 console.error('Error fetching DJs:', error);
 } finally {
 setLoading(false);
 }
 };

 return (
 <Container maxWidth="lg" sx={{ mt: 4 }}>
 <Typography
 variant="h2"
 sx={{
 textAlign: 'center',
 mb: 2,
 fontWeight: 700,
 letterSpacing: '0.1em'}}
 >
 NUESTROS DJs
 </Typography>

 <Typography
 variant="h5"
 sx={{
 textAlign: 'center',
 mb: 6,
 opacity: 0.8,
 fontWeight: 300}}
 >
 Los mejores talentos detrás del micrófono
 </Typography>

 <Grid container spacing={4}>
 {loading
 ? Array.from(new Array(6)).map((_, index) => (
 <Grid item xs={12} sm={6} md={4} key={index}>
 <Card sx={{ bgcolor: 'background.paper' }}>
 <Skeleton variant="rectangular" height={300} />
 <CardContent>
 <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
 <Skeleton variant="text" />
 <Skeleton variant="text" />
 </CardContent>
 </Card>
 </Grid>
 ))
 : djs.map((dj) => (
 <Grid item xs={12} sm={6} md={4} key={dj.id}>
 <Card
 sx={{
 height: '100%',
 display: 'flex',
 flexDirection: 'column',
 background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
 transition: 'transform 0.3s',
 '&:hover': {
 transform: 'translateY(-10px)'}}}
 >
 {dj.photo ? (
 <CardMedia
 component="img"
 height="300"
 image={`${API_URL}${dj.photo}`}
 alt={dj.name}
 sx={{ objectFit: 'cover' }}
 />
 ) : (
 <Box
 sx={{
 height: 300,
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 bgcolor: 'background.default'}}
 >
 <PersonIcon sx={{ fontSize: 100, opacity: 0.3 }} />
 </Box>
 )}
 <CardContent sx={{ flex: 1 }}>
 <Typography
 variant="h5"
 sx={{
 mb: 2,
 fontWeight: 700,
 letterSpacing: '0.05em',
 color: 'primary.main'}}
 >
 {dj.name}
 </Typography>
 <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
 {dj.bio}
 </Typography>
 <Box sx={{ display: 'flex', gap: 1 }}>
 {dj.social_instagram && (
 <IconButton
 href={dj.social_instagram}
 target="_blank"
 sx={{
 color: 'text.secondary',
 '&:hover': { color: 'primary.main' }}}
 >
 <InstagramIcon />
 </IconButton>
 )}
 {dj.social_facebook && (
 <IconButton
 href={dj.social_facebook}
 target="_blank"
 sx={{
 color: 'text.secondary',
 '&:hover': { color: 'primary.main' }}}
 >
 <FacebookIcon />
 </IconButton>
 )}
 </Box>
 </CardContent>
 </Card>
 </Grid>
 ))}
 </Grid>

 {!loading && djs.length === 0 && (
 <Box sx={{ textAlign: 'center', py: 8 }}>
 <PersonIcon sx={{ fontSize: 100, opacity: 0.3, mb: 2 }} />
 <Typography variant="h5" color="text.secondary">
 Pronto añadiremos información sobre nuestros DJs
 </Typography>
 </Box>
 )}
 </Container>
 );
};

export default DJs;